<template>
  <div class="noticeList">
    <mt-navbar
      v-model="selected"
      fixed
    >
      <mt-tab-item
        id="notice"
        @click.native="getNoticeList()"
      >通知</mt-tab-item>
      <mt-tab-item
        id="message"
        @click.native="getMessageList()"
      >消息</mt-tab-item>
    </mt-navbar>
    <!-- tab-container -->
    <mt-tab-container v-model="selected">
      <mt-tab-container-item id="notice">
        <div
          class="noticeList_items"
          v-for="item in noticeList"
          :key="item.id"
        >
          <router-link
            :to="{path:'/nd',query:{id:item.Id,type:1}}"
            @click.native='setStatus(item.ReadStatus,{userId:uId,companyId:cId,noticeId:item.Id,noticeType:"1"})'
          >
            <ul class="flexS">
              <li class="noticeTit">{{item.Title}}</li>
              <li class="noticeDate">{{item.CreateDate,'true'|moment}}</li>
            </ul>
            <ul class="flexS">
              <li
                class="noticeInstro"
                v-html="item.NoticeContent"
              ></li>
              <li v-show="!item.ReadStatus"><i class="unRead"></i></li>
            </ul>
          </router-link>
        </div>
        <div
          v-show="isHasdata2"
          class="noData"
        >
          <img
            src="../assets/imgs/noDataIcon.png"
            alt=""
          >
          <p class="noDataTit">未查询到相关数据</p>
          <p>暂无数据，请刷新重试</p>
        </div>
      </mt-tab-container-item>
      <mt-tab-container-item id="message">
        <div
          class="noticeList_items"
          v-for="item in messageList"
          :key="item.id"
        >
          <router-link
            :to="{path:'/nd',query:{id:item.id,type:2}}"
            @click.native='setStatus(item.Status,{userId:uId,companyId:cId,noticeId:item.id,noticeType:"2"})'
          >
            <ul class="flexS">
              <li class="noticeTit">{{item.title}}</li>
              <li class="noticeDate">{{item.send_time,'true'|moment}}</li>
            </ul>
            <ul class="flexS">
              <li
                class="noticeInstro"
                v-html="item.content"
              ></li>
              <li v-show="!item.Status"><i class="unRead"></i></li>
            </ul>
          </router-link>
        </div>
        <div
          v-show="isHasdata"
          class="noData"
        >
          <img
            src="../assets/imgs/noDataIcon.png"
            alt=""
          >
          <p class="noDataTit">未查询到相关数据</p>
          <p>暂无数据，请刷新重试</p>
        </div>
      </mt-tab-container-item>
    </mt-tab-container>
  </div>
</template>
<script>
import { noticeLists, messageLists, setStatus } from '../../src/api/Api'
// import Back from '../components/Back'
export default {
  name: 'userinfos',
  components: {},
  data () {
    return {
      myPageTit: '消息公示',
      selected: 'notice',
      noticeList: [],
      messageList: [],
      uId: sessionStorage.getItem('userId'),
      cId: sessionStorage.getItem('companyId'),
      isHasdata: false,
      isHasdata2: false
    }
  },
  created () {
    this.getNoticeList()
  },
  methods: {
    getNoticeList () {
      var _this = this
      noticeLists({
        userId: sessionStorage.getItem('userId'),
        companyId: sessionStorage.getItem('companyId')
      }).then(res => {
        if (res.data.code === 200) {
          _this.isHasdata2 = false
          _this.noticeList = res.data.data
          if (res.data.data.length < 1) {
            _this.isHasdata2 = true
          }
        } else {
          _this.isHasdata2 = true
        }
      })
    },
    getMessageList () {
      var _this = this
      messageLists({
        userId: sessionStorage.getItem('userId'),
        companyId: sessionStorage.getItem('companyId')
      }).then(res => {
        if (res.data.code === 200) {
          _this.isHasdata = false
          _this.messageList = res.data.data
        } else {
          _this.isHasdata = true
        }
      })
    },
    setStatus (isReady, obj) {
      if (!isReady) {
        setStatus(obj).then(res => {
          console.log(res.data.code)
          if (res.data.code === 200) {
            console.log('success')
          }
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/NoticeList.vue